/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dr_Room_Val3_DescInputs */

const en_dr_room_val3_desc = /** @type {(inputs: Dr_Room_Val3_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Each feature in the resulting PRD links back to the card, the hypothesis and the vote that produced it — Proof-of-Why, not just Proof-of-Done.`)
};

const id_dr_room_val3_desc = /** @type {(inputs: Dr_Room_Val3_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Setiap fitur di PRD yang terbit tertaut balik ke kartu, hipotesis, dan suara yang melahirkannya — Proof-of-Why, bukan sekadar Proof-of-Done.`)
};

/**
* | output |
* | --- |
* | "Each feature in the resulting PRD links back to the card, the hypothesis and the vote that produced it — Proof-of-Why, not just Proof-of-Done." |
*
* @param {Dr_Room_Val3_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const dr_room_val3_desc = /** @type {((inputs?: Dr_Room_Val3_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dr_Room_Val3_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_dr_room_val3_desc(inputs)
	return en_dr_room_val3_desc(inputs)
});